import { chunk } from 'es-toolkit';
import type { MappingFunction } from '../types';

const ONE_PAGE = 1;

export const generateDataChunks = (
  data: unknown[],
  itemsPerChunk: number,
  activeChunkIndex: number,
  renderItem: MappingFunction,
  renderLoader: MappingFunction,
  isLoopActive: boolean
) => {
  const chunkedData = chunk(data, itemsPerChunk);

  return chunkedData.map((oneChunk: unknown[], chunkIndex: number) => {
    const key = chunkIndex * itemsPerChunk;
    const isActiveChunk =
      chunkIndex === activeChunkIndex ||
      chunkIndex + ONE_PAGE === activeChunkIndex ||
      chunkIndex - ONE_PAGE === activeChunkIndex ||
      (isLoopActive && chunkIndex === 0) ||
      (isLoopActive && chunkIndex === chunkedData.length - 1);

    return oneChunk.map((item: unknown, index: number, array: unknown[]) => {
      if (isActiveChunk && item) {
        return renderItem(item, key + index, array);
      }
      return renderLoader(item, key + index, array);
    });
  });
};
